import { identify, makeRequest, Service } from 'utils/http';

export async function getOrderDocumentApi(orderId: string) {
  return makeRequest(Service.getOrderDocument(orderId, await identify()));
}
